<script>
import ServiceDeskBlock from "./ServiceDeskBlock.vue";

export default {
    name: "ServiceDeskNavbar",
    components: {ServiceDeskBlock},
    data: () => ({
        modal_state: false,
        not_viewed: 0,
        isLoading: false,
    }),
    mounted() {
        this.fetchNotViewed();

        let self = this;
        Echo.private(`user.${this.$store.getters['auth/user'].id}`)
            .listen('.servicedesk.request.updated', function (e) {
                self.fetchNotViewed();
            })
    },
    beforeDestroy() {

    },
    watch: {
        modal_state(val) {
            if (val) this.not_viewed = 0;
        }
    },
    methods: {
        fetchNotViewed() {
            let self = this;
            axios.get('/api/servicedesk/not-viewed')
                .then(r => {
                    self.not_viewed = r.data;
                })
        }
    }
}
</script>

<template>
    <li class="nav-item dropdown">
        <a class="nav-icon" href="#" @click.prevent="modal_state = true"><i v-loading="isLoading" class="fas fa-question-circle"></i><span v-if="not_viewed" class="badge badge-success counter">{{ not_viewed }}</span></a>
        <el-dialog :visible.sync="modal_state" width="600px" :append-to-body="true" title="Служба поддержки" >
            <ServiceDeskBlock v-if="modal_state" />
        </el-dialog>
    </li>
</template>

<style scoped>
.counter {
    font-size: 0.8rem;
    position: absolute;
    top: 2px;
    left: 32px;
    padding: 3px;
}
</style>